import { useSelector } from "react-redux";
import Wrapper from "../../components/Wrapper";
import ChatBot from "./Chatbot";
import Dashboard from "./Dashboard";

const UserDashboard = () => {
  const { currentDashboardNav } = useSelector((s) => s.userDashboard);

  // console.log(currentDashboardNav, "dash");
  return (
    <Wrapper>
      <div>
        {currentDashboardNav === "Dashboard" ? (
          <Dashboard />
        ) : currentDashboardNav === "ChatBot" ? (
          <ChatBot />
        ) : (
          "hii"
        )}
      </div>
    </Wrapper>
  );
};

export default UserDashboard;
